import type { ItemOverrideSelectionField } from "@forgepoint/shared";

/** Display label for each field a quote line can override. */
export const ITEM_OVERRIDE_FIELD_LABELS: Record<
  ItemOverrideSelectionField,
  string
> = {
  length: "Length",
  width: "Width",
  height: "Height",
  weight: "Weight",
  allowance: "Allowance",
  dimensionUnit: "Dimension unit",
};
